import "core-js/modules/es.array.every";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.some";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import Immutable from 'immutable';
import FormRecord from '../../lib/records/FormRecord';
import FieldRecord from '../../lib/records/FieldRecord';
export var getBrand = function getBrand(_ref) {
  var digitalCore = _ref.digitalCore;
  return digitalCore.brand;
};
export var getStrings = function getStrings(_ref2) {
  var digitalCore = _ref2.digitalCore;
  return digitalCore.strings;
};
export var getFragments = function getFragments(_ref3) {
  var digitalCore = _ref3.digitalCore;
  return digitalCore.fragments;
};
export var getDevice = function getDevice(_ref4) {
  var digitalCore = _ref4.digitalCore;
  return digitalCore.device;
};
export var getForm = function getForm(state, formId) {
  return state.digitalCore.forms.get(formId) || new FormRecord({
    formId: formId
  });
};
export var getField = function getField(state, fieldKey) {
  return state.digitalCore.fields.get(fieldKey) || new FieldRecord({
    fieldKey: fieldKey
  });
};
export var getFieldValue = function getFieldValue(state, fieldKey) {
  return getField(state, fieldKey).value;
};
export var getFormFields = function getFormFields(state, formId) {
  return state.digitalCore.fields.filter(function (field) {
    return field.formId === formId;
  });
};
export var getFormLabels = function getFormLabels(state, formId) {
  return state.digitalCore.labels.filter(function (label) {
    return label.formId === formId;
  });
};
export var getFormLabel = function getFormLabel(state, formId, fieldKey) {
  return state.digitalCore.labels.filter(function (label) {
    return label.formId === formId;
  }).get(fieldKey);
};
export var isFormDirty = function isFormDirty(state, formId) {
  return getFormFields(state, formId).some(function (field) {
    return field.dirty;
  });
};
export var isFormPristine = function isFormPristine(state, formId) {
  return getFormFields(state, formId).every(function (field) {
    return field.pristine;
  });
};
export var getDependentElements = function getDependentElements(state, formId) {
  return state.digitalCore.formDependencies.getIn([formId]) || Immutable.Map();
};
export var getDependentElement = function getDependentElement(state, formId, fieldId) {
  return state.digitalCore.formDependencies.getIn([formId, fieldId]);
};
export var getInterdiction = function getInterdiction(_ref5) {
  var digitalCore = _ref5.digitalCore;
  return digitalCore.interdiction;
};
export var filteredChildWindows = function filteredChildWindows(_ref6, filter) {
  var digitalCore = _ref6.digitalCore;
  return digitalCore.childWindows.childWindows.filter(filter);
};
export var getNonFetchingCms = function getNonFetchingCms(state, ids) {
  return ids.filter(function (id) {
    return state.digitalCore.cms.get(id) && state.digitalCore.cms.getIn([id, 'isFetching']) && !state.digitalCore.cms.getIn([id, 'data']).size;
  });
};
export var getFetchingWFCmsIds = function getFetchingWFCmsIds(state, cmsIds) {
  var components = state.digitalCore.wfCms.get('components');
  return cmsIds.filter(function (cmsId) {
    return components.get(cmsId) && components.getIn([cmsId, 'isFetching']) && !components.getIn([cmsId, 'data']).size;
  });
};